import { Deserializable } from '../../deserializable';
import { SavableFilter } from './../savable-filter.model';
import { BaseAdvancedFilterOptions } from './base-advanced-filter-options.model';
import { GridPageOptions } from './grid-page-options.model';

export class BaseFilterOptions<Filters extends BaseAdvancedFilterOptions> implements Deserializable, SavableFilter {
  public FilterCategory: string;
  public SearchText: string;
  public SaveSearch: boolean;
  public SearchSaveName: string;
  public GridOptions: GridPageOptions;
  public AdvancedFilters: Filters;

  constructor() {
    this.GridOptions = new GridPageOptions();
    this.AdvancedFilters = new BaseAdvancedFilterOptions() as Filters;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    this.GridOptions = new GridPageOptions().deserialize(input.GridOptions);
    this.AdvancedFilters = new BaseAdvancedFilterOptions().deserialize(input.AdvancedFilters) as Filters;

    return this;
  }
}
